module.exports = __webpack_public_path__ + "static/media/ico_hdfc_512.8b93f597.png";